export const state = () => ({
  customer: {},
  purchaser: null,
})
